module.exports = require("./bs-Cyrl");